module.exports = __webpack_public_path__ + "img/draco.426012c4.png";